import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { MERCHANT_SLICE } from "./sliceNames";
import { MERCHANT_INITIAL_VALUE } from "constants/initialValue";
import { IMerchant } from "interfaces/Merchant/merchant.interface";
import { IMerchantState } from "interfaces/redux/reducers";

interface IUpdateMerchantPayload {
  merchants?: IMerchant[];
  is_merchants_loading?: boolean;
  is_merchants_empty?: boolean;
}

const merchantSlice = createSlice({
  name: MERCHANT_SLICE,
  initialState: MERCHANT_INITIAL_VALUE,
  reducers: {
    updateMerchantsReducer: (state, action: PayloadAction<IUpdateMerchantPayload>): IMerchantState => {
      const { is_merchants_loading = false, merchants = [], is_merchants_empty = false } = action.payload;

      return {
        ...state,
        merchants,
        is_merchants_loading: !!is_merchants_loading,
        is_merchants_empty: !!is_merchants_empty,
      };
    },
  },
});

export const { updateMerchantsReducer: actionUpdateMerchantsReducer } = merchantSlice.actions;

export default merchantSlice.reducer;
